<mat-spinner *ngIf="loading" [diameter]="size"></mat-spinner>